import { IdentificationClient } from '@frontend/identification/api';
import { Identification, IdentificationType } from '@frontend/identification/types';
import { useEffect, useState } from 'react';

import { ItsmeCardProps } from './itsme-card.component';

export const useItsmeCard = (props: ItsmeCardProps) => {
    const [itsme, setItsme] = useState<Identification | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        IdentificationClient.fetchIdentifications({ entity_id: props.entity_id, type: IdentificationType.ITSME })
            .then((response) => {
                setItsme(response.results[0] ?? null);
            })
            .catch(() => {
                setItsme(null);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [props.entity_id]);

    return {
        itsme,
        isLoading
    };
};
